export default "__VITE_ASSET__fd488e08__"